module.exports = __webpack_public_path__ + "static/media/10.d432c930.png";